import Vue from 'vue'

export default {
  getCgvDirectoryFileEntries() {
    return require.context('../assets/legal/cgv/', true, /\.txt$/)
  },

  getRgpdLastDirectoryFileEntry() {
    return require.context('../assets/legal/rgpd/', true, /\.txt$/)
  },

  getCgvLastFileEntry() {
    let cgvFiles = {}
    let cgvDirFiles = this.getCgvDirectoryFileEntries()
    // Loop on each files of directory
    cgvDirFiles.keys().forEach((filename) => {
      // format: ./cgv_xxxx_zzzz-zz-zz with ./ is added by require.context, xxxx is role (type) and zzzz-zz-zz the date
      let cgvRoleType = filename.split('_')[1]

      // Define dynamic key / value object
      cgvFiles[cgvRoleType] = {
        filesName: [],
        lastFileName: '',
        lastFileContent: ''
      }

      // Fill object
      cgvFiles[cgvRoleType].filesName.push(filename)
      cgvFiles[cgvRoleType].lastFileName = filename // at least will be the last file of cgv dir for role type cause of date format
      cgvFiles[cgvRoleType].lastFileContent = cgvDirFiles(filename).default
    })
    return cgvFiles
  },

  async isLegalsAgreed(user) {
    let acceptedConditions = false
    let acceptedRgpd = false

    // CGU/V & RGPD
    let cdtsRes = await Vue.axios.get(`/users/${user.id}/conditions`)
    let rgpdsRes = await Vue.axios.get(`/users/${user.id}/rgpd`)

    let currentConditionsFilename =
      this.readFormattedTermsAndCondition(user).filename
    acceptedConditions = cdtsRes.data.includes(`"${currentConditionsFilename}"`)

    let currentRgpdFilename = this.readFormattedRGPD().filename
    acceptedRgpd = rgpdsRes.data.includes(`"${currentRgpdFilename}"`)

    if (!acceptedConditions || !acceptedRgpd) {
      return false
    } else {
      return true
    }
  },

  readFormattedTermsAndCondition(user) {
    // Set default date if null date provided
    let activationDate = new Date()
    let terminationDate = new Date() // for users, it is not used
    terminationDate.setDate(activationDate.getDate() + 7 * 4) // 4 weeks per default
    let userRole = null
    if (user != null) {
      userRole = user.type
      if (user.activation != null) {
        activationDate = new Date(user.activation)
        terminationDate.setDate(activationDate.getDate() + 7 * 4) // 4 weeks per default
      }
      if (user.expiration != null) {
        terminationDate = new Date(user.expiration)
      }
    }

    let termsAndConditions = { content: null, filename: null }
    let changeTextFormatting = true

    // Manage last version of cgv files
    let cgvFiles = this.getCgvLastFileEntry()

    // Select the good terms & conditions based on user role
    if (typeof cgvFiles[userRole] !== 'undefined') {
      changeTextFormatting = userRole !== 'none'
      termsAndConditions.filename = '"' + cgvFiles[userRole].lastFileName + '"'
      termsAndConditions.content = cgvFiles[userRole].lastFileContent
    } else {
      changeTextFormatting = false
      termsAndConditions.filename = '"' + cgvFiles.default.lastFileName + '"'
      termsAndConditions.content = cgvFiles.default.lastFileContent
    }

    // Replace date
    if (changeTextFormatting === true) {
      let dateInContract = activationDate.toLocaleDateString('fr') // (DD/MM/YYYY)
      let terminationDateInContract = terminationDate.toLocaleDateString('fr') // (DD/MM/YYYY)
      termsAndConditions.content = this.formatTextToHTML(
        termsAndConditions.content
          .replace('[EFFECTIVE_DATE]', dateInContract)
          .replace('[TERMINATION_DATE]', terminationDateInContract)
      )
      termsAndConditions.content =
        termsAndConditions.content +
        '<br/>If you do not agree with terms please contact <a href="mailto:spacestudio@exotrail.com">spacestudio@exotrail.com</a><br/>'
    }

    return termsAndConditions
  },

  readFormattedRGPD() {
    let rgpdFiles = []
    let rgpd = { content: '', filename: null }

    // Manage last version of rgpd files
    let rgpdDirFiles = this.getRgpdLastDirectoryFileEntry()
    rgpdDirFiles.keys().forEach((filename) => {
      rgpdFiles.push(filename)
    })

    // Get last version
    rgpd.filename = '"' + rgpdFiles[rgpdFiles.length - 1] + '"'
    rgpd.content = 
    this.formatTextToHTML(
      rgpdDirFiles(rgpdFiles[rgpdFiles.length - 1]).default
    )

    return rgpd
  },

  formatTextToHTML(text) {
    let formattedText = text.replace(
      /^ *([0-9]+\.[0-9]+\.?[ \t].*)/gm,
      '\n<h5>$1</h6>'
    )
    formattedText = formattedText.replace(
      /^ *([0-9]+\.?[ \t].*)/gm,
      '\n<h4>$1</h4>'
    )
    formattedText = formattedText.replace(/h6>\n/gm, 'h6>')
    formattedText = formattedText.replace(/h5>\n/gm, 'h5>')
    formattedText = formattedText.replace(/h4>\n/gm, 'h4>')
    formattedText = formattedText.replace(/\n\n+/gm, '\n\n')
    formattedText = formattedText.replace(/\n/gm, '<br/>')
    return formattedText
  },

  backgroundStarStyle() {
    return (
      'background: #3BE287'
    )
  }
}
